import React from 'react'
import { X, Download, ExternalLink } from 'lucide-react'

const DocumentViewerModal = ({ isOpen, onClose, document: doc }) => {
  if (!isOpen || !doc) return null

  const handleDownload = () => {
    if (doc.url) {
      const link = document.createElement('a')
      link.href = doc.url
      link.download = doc.fileName || doc.name || 'document'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const handleOpenInNewTab = () => {
    if (doc.url) {
      window.open(doc.url, '_blank')
    }
  }

  // Determine if it's a PDF or image
  const isPDF = doc.url && (doc.url.toLowerCase().endsWith('.pdf') || doc.type === 'application/pdf')
  const isImage = doc.url && (
    doc.url.toLowerCase().endsWith('.jpg') ||
    doc.url.toLowerCase().endsWith('.jpeg') ||
    doc.url.toLowerCase().endsWith('.png') ||
    doc.type?.startsWith('image/')
  )

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[10000] p-4 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-900 rounded-2xl w-full max-w-6xl h-[90vh] flex flex-col overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
        
        {/* Toolbar */}
        <div className="flex items-center justify-between p-4 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 z-10">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg text-primary-600 dark:text-primary-400">
              {isPDF ? <span className="font-bold text-xs uppercase">PDF</span> : <span className="font-bold text-xs uppercase">IMG</span>}
            </div>
            <div>
              <h3 className="text-base font-bold text-slate-800 dark:text-slate-200 max-w-md truncate" title={doc.name}>
                {doc.name || 'Document Viewer'}
              </h3>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <button 
              onClick={handleDownload} 
              className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors text-slate-500 hover:text-primary-600 dark:hover:text-primary-400" 
              title="Download"
            >
              <Download className="w-5 h-5" />
            </button>
            <button 
              onClick={handleOpenInNewTab} 
              className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors text-slate-500 hover:text-primary-600 dark:hover:text-primary-400" 
              title="Open New Tab"
            >
              <ExternalLink className="w-5 h-5" />
            </button>
            <div className="w-px h-6 bg-slate-200 dark:bg-slate-700 mx-2"></div>
            <button 
              onClick={onClose} 
              className="p-2 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors text-slate-500 hover:text-red-600 dark:hover:text-red-400"
              title="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 bg-slate-50 dark:bg-slate-950/50 overflow-hidden flex items-center justify-center p-4">
          {doc.url ? (
            <div className="w-full h-full flex items-center justify-center overflow-auto">
              {isPDF ? (
                <iframe
                  src={`${doc.url}#toolbar=0`}
                  className="w-full h-full rounded-lg shadow-sm bg-white"
                  title={doc.name || 'Document'}
                />
              ) : isImage ? (
                <img
                  src={doc.url}
                  alt={doc.name}
                  className="max-w-full max-h-full rounded-lg shadow-sm object-contain"
                />
              ) : (
                <div className="text-center p-8 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800">
                  <p className="text-slate-500 dark:text-slate-400 mb-4">Preview not available for this file type</p>
                  <button 
                    onClick={handleDownload} 
                    className="btn-primary"
                  >
                    Download to View
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center">
              <p className="text-slate-400">No document URL provided</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DocumentViewerModal

